import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectMerchantDetails,
  selectFrontendBackUrl,
  selectHeaderTextColor,
} from "../../../slices/PaymentSessionDetailsSlice";
import { generateDynamicLogo, isEmpty } from "../../../Utils/utils";
import "./navBarCheckout.css";
import { Typography, Dropdown } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import ErrorModal from "../../components/modals/errorModal/ErrorModal";
import { useTranslation } from "react-i18next";
import { setSelectedLanguage } from "../../../slices/CommonPersistedSlice";
import {
  paymentCancelledEvent,
  languageClickedEvent,
  languageSelectedEvent,
  backButtonClickedEvent,
  backButtonModalConfirmedEvent,
  backButtonModalCancelledEvent,
} from "../../../Utils/uiAnalytics";

const LANGUAGE_LABELS = {
  en: "ENGLISH",
  hn: "HINDI",
  mr: "MARATHI",
  ta: "TAMIL",
  zh: "MANDARIN",
  vi: "VIETNAMESE",
  id: "BAHASA",
  ko: "KOREAN",
  es: "SPANISH",
};

const Navbar = () => {
  const headerTextColor = useSelector((state) => selectHeaderTextColor(state));
  const merchantDetails = useSelector((state) => SelectMerchantDetails(state));
  const frontendBackUrl = useSelector((state) => selectFrontendBackUrl(state));
  const [open, setOpen] = useState(false);
  const callerType = useSelector((state) => state.paymentSessionDetails.callerType);
  const isMerchantLogo = useSelector((state) => state.additionalComponents.isMerchantLogo);
  const sampleToken = useSelector((state) => state.paymentSessionDetails.sampleToken);
  const selectedLanguage = useSelector((state) => state.commonPersisted.selectedLanguage);

  const isIframe = window.self !== window.top;
  const enableLocalisation = useSelector((state) => state.commonPersisted.enableLocalisation);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const handleChange = (value) => {
    languageSelectedEvent(LANGUAGE_LABELS[value] || value);
    dispatch(setSelectedLanguage(value))
    i18n.changeLanguage(value);
  };

  const handleLanguageIconClick = () => {
    languageClickedEvent();
  };
  const currentLanguage = isEmpty(selectedLanguage) ? 'en' : selectedLanguage;
  const languageMenuItems = [
    { key: 'en', label: t('ENGLISH') },
    { key: 'hn', label: t('HINDI') },
    { key: 'mr', label: t('MARATHI') },
    { key: 'ta', label: t('TAMIL') },
    { key: 'zh', label: t('MANDARIN') },
    { key: 'vi', label: t('VIETNAMESE') },
    { key: 'id', label: t('BAHASA') },
    { key: 'ko', label: t('KOREAN') },
    { key: 'es', label: t('SPANISH') },
  ];
  const handleConfirmClick = () => {
    backButtonModalConfirmedEvent();
    paymentCancelledEvent()
    if (isIframe) {
      const message = {
        action: 'paymentCancelled',
      };
      window.parent.postMessage(message, '*');
    } else {
      window.location.href = frontendBackUrl;
    }
  }

  const handleBackButtonClick = () => {
    backButtonClickedEvent();
    setOpen(true);
  }

  const handleCancelModalClick = () => {
    backButtonModalCancelledEvent();
    setOpen(false);
  }
  return (
    <div className="domestic-navbar-root dynamic-header">
      <ErrorModal
        icon={<CloseCircleOutlined style={{ color: "#FAAD14", fontSize: "22px" }} />}
        title={`${t("CANCEL_ORDER_CONFIRMATION")}?`}
        desc={t("PROGRESS_LOST_ORDER_NOT_COMPLETED")}
        showModal={open}
        primaryOnClick={handleConfirmClick}
        secondaryOnClick={handleCancelModalClick}
        primaryBtnText={"Yes, cancel"}
        secondaryBtnText={"No"}
        showSecondaryButton={true}
      />
      <div className="nav-header-checkout">
        <div className="nav-header-container">

          {(!location.pathname.includes("finalStatus") && (callerType === 'CHECKOUT' && frontendBackUrl)) && !sampleToken && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleBackButtonClick}
            >
              {generateDynamicLogo(
                "leftArrow",
                "24px",
                "24px",
                "",
                headerTextColor
              )}
            </div>
          )}
          {isMerchantLogo && merchantDetails?.logoUrl && (
            <img className="nav-logo-checkout" src={merchantDetails?.logoUrl} />
          )}
          <Typography
            style={{
              color: headerTextColor,
              fontWeight: '600',
              fontSize: '16px'
            }}
          >
            {merchantDetails?.merchantName}{" "}
          </Typography>
        </div>
        <div className="nav-select-box">
          {
            enableLocalisation && (
              <Dropdown
                menu={{
                  items: languageMenuItems,
                  selectable: true,
                  selectedKeys: [currentLanguage],
                  onClick: ({ key }) => handleChange(key),
                }}
                trigger={["click"]}
                placement="bottomRight"
              >
                <div className="nav-language-icon-btn" onClick={handleLanguageIconClick}>
                  <img src="/assets/translate.png" alt="translate" width={22} height={22} />
                </div>
              </Dropdown>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default Navbar;
